import {
  IAlertBaseContext,
  useAlertBaseSeverity,
} from '../AlertBase/AlertBaseContext';
import { AlertBaseAction, AlertBaseActionProps } from '../AlertBaseAction';
import { getAlertBaseUtilityClass } from '../AlertBase/alertBaseClasses';
import { capitalize, styled } from '@mui/material';
import { globalMuiClasses } from 'src/utils/cssSelectorConstants';
import { getToken } from '@workiva/unify-tokens';
import * as React from 'react';
import { getAlertBaseStyledOverridesResolver } from '../AlertBase/styledAlertBaseOverridesResolver';

export type BannerActionProps = AlertBaseActionProps;

type UnifyBannerActionOwnerState = Required<
  Pick<IAlertBaseContext, 'severity'>
>;

const UnifyBannerActionRoot = styled(AlertBaseAction, {
  name: 'UnifyBannerAction',
  slot: 'Root',
  overridesResolver: getAlertBaseStyledOverridesResolver('child'),
})<AlertBaseActionProps & { ownerState: UnifyBannerActionOwnerState }>(
  ({ ownerState }) => {
    const { severity } = ownerState;
    const colorToken = severity === 'warning' ? 'onWarning' : 'onColor';

    return {
      [`.${getAlertBaseUtilityClass(`severity${capitalize(severity)}`)} &`]: {
        color: getToken(`Component/Banner/banner-action-${colorToken}`),

        [`&:hover, &.${globalMuiClasses.focusVisible}`]: {
          color: getToken(`Component/Banner/banner-action-${colorToken}-hover`),
        },
      },
    };
  }
);

/**
 * Use the `BannerAction` component within the `actions` prop of a `Banner` to display up to two actions.
 */
export const BannerAction = React.forwardRef<
  HTMLButtonElement,
  BannerActionProps
>(function BannerAction(props, ref) {
  const severity = useAlertBaseSeverity();
  return (
    <UnifyBannerActionRoot {...props} ref={ref} ownerState={{ severity }} />
  );
});

export default BannerAction;
